// extracted by mini-css-extract-plugin
export default {"nh":"Reports_nh__LipAU","active":"Reports_active__56tJB","invisible":"Reports_invisible__BDG-m"};